import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// routes order matters!
const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('../login/module').then(m => m.LoginModule),
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('../forgot-password/module').then(m => m.ForgotPasswordModule),
  },
  {
    path: 'reset-password',
    loadChildren: () => import('../reset-password/module').then(m => m.ResetPasswordModule),
  },
  {
    path: 'approval',
    loadChildren: () => import('../request-approval/module').then(m => m.RequestApprovalModule),
  },
  {
    path: 'customer-management',
    loadChildren: () => import('../customer-manager/module').then(m => m.CustomerManagerModule),
  },
  {
    path: 'customized-release-report',
    loadChildren: () => import('../customized-release-report/module').then(m => m.CustomizedReleaseReportModule),
  },
  {
    path: 'common-repository-management',
    loadChildren: () => import('../common-repo-management/module').then(m => m.CommonRepoManagementModule),
  },
  {
    path: 'framework-release-management',
    loadChildren: () => import('../framework-release-management/module').then(m => m.FrameworkReleaseManagementModule),
  },
  {
    path: 'user-management',
    loadChildren: () => import('../user-management/module').then(m => m.UserManagementModule),
  },
  {
    path: 'email-settings',
    loadChildren: () => import('../email-settings/module').then(m => m.EmailSettingsModule),
  },
  {
    path: 'ie-initialization',
    loadChildren: () => import('../ie-initialization/module').then(m => m.IeInitializationModule),
  },
  {
    path: 'version-management',
    loadChildren: () => import('../version-management/module').then(m => m.VersionManagementModule),
  },
  {
    path: '',
    loadChildren: () => import('../main-ui/module').then(m => m.MainUiModule),
  },
  {
    path: '**',
    redirectTo: 'login',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
  declarations: [],
  providers: [],
})
export class RootRoutingModule {}
